export default __webpack_public_path__ + "static/media/logo-airpartenairesante.d8b5c8f3.png";